import { render } from "./PayloadComposition.vue?vue&type=template&id=154c6725&scoped=true&ts=true"
import script from "./PayloadComposition.vue?vue&type=script&lang=ts"
export * from "./PayloadComposition.vue?vue&type=script&lang=ts"

import "./PayloadComposition.vue?vue&type=style&index=0&id=154c6725&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154c6725"]])

export default __exports__